import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { helpCategories } from "./helpData";
import HelpCenterLayout from "./HelpCenterLayout";
import Breadcrumbs from "./Breadcrumbs";
import ArticleList from "./ArticleList";
import "../../css/HelpCenter.css";

const HelpCategoryDetails = () => {
  const { categoryId } = useParams();
  const category = useMemo(
    () => helpCategories.find((item) => item.id === categoryId),
    [categoryId]
  );

  useEffect(() => {
    document.title = category
      ? `VelaKoda | ${category.title}`
      : "VelaKoda | Help Center";
  }, [category]);

  if (!category) {
    return (
      <HelpCenterLayout backFallbackTo="/help">
        <Breadcrumbs
          items={[
            { label: "All Collections", to: "/help" },
            { label: "Category not found", muted: true },
          ]}
        />
        <header className="help-page-header">
          <h1 className="help-page-title">Category not found</h1>
        </header>
        <div className="help-empty-state">
          Please choose a different topic from the Help Center.
        </div>
      </HelpCenterLayout>
    );
  }

  return (
    <HelpCenterLayout backFallbackTo="/help">
      <Breadcrumbs
        items={[
          { label: "All Collections", to: "/help" },
          { label: category.title },
        ]}
      />

      <header className="help-page-header">
        <h1 className="help-page-title">{category.title}</h1>
        <p className="help-page-subtitle">
          {category.summary} ({category.articles.length} articles)
        </p>
      </header>

      <div className="help-list-shell">
        <ArticleList articles={category.articles} basePath={`/help/${category.id}`} />
      </div>
    </HelpCenterLayout>
  );
};

export default HelpCategoryDetails;
